<template>
  <div class="bg-white rounded-lg p-2">
    <div class="flex justify-center flex-row">
      <LoadingSpinner
        class="h-10 w-10 text-yellow-500/80 my-8"
        v-if="loading"
      />
      <apexchart
        class=""
        type="pie"
        width="350"
        :options="options"
        :series="series"
        v-else-if="this.series.length"
      />
      <h6 class="my-8 text-gray-600" v-else>بدون داده</h6>
    </div>
  </div>
</template>
<script>
import { saleProductReport } from "../API/API";
import LoadingSpinner from "../components/General/LoadingSpinner.vue";

export default {
  name: "SaleProductChart",
  components: { LoadingSpinner },
  props: ["year", "month", "day"],
  data() {
    return {
      loading: true,
      series: [],
      options: {
        fontFamily: "iransans",
        // dataLabels: {
        //   enabled: true,
        // },
        // legend: {
        //   show: false,
        // },
        // sparkline: {
        //   enabled: true,
        // },
        labels: [],
        tooltip: {
          y: {
            formatter: function (value) {
              return value;
            },
          },
        },
        colors: [
          "#EF4444",
          "#F97316",
          "#F59E0B",
          "#84CC16",
          "#06B6D4",
          "#6366F1",
          "#A855F7",
          "#F43F5E",
          "#EC4899",
          "#10B981",
          "#3B82F6",
          "#1E40AF",
          "#065F46",
          "#4D7C0F",
          "#3730A3",
          "#6B21A8",
          "#9D174D",
        ],
      },
    };
  },
  created() {
    this.getReports();
  },
  methods: {
    getReports() {
      this.series = [];
      this.options.labels = [];
      this.loading = true;
      saleProductReport("year", "qty", this.year, this.month, this.day).then(
        (resp) => {
          resp.data.result.yaxis.forEach((item) => {
            this.options.labels.push(item.name);
            if (item.dData.length) {
              this.series.push(item.dData[0]);
            }
          });
          this.loading = false;
        }
      );
    },
  },
  watch: {
    day() {
      if (this.day !== "") this.getReports();
    },
    month() {
      this.getReports();
    },
    year() {
      this.getReports();
    },
  },
};
</script>
